export default {
  ActivityLogImportJob: 'Импорт журнала активности',
  AllSurveysDataMigrationJob: 'Миграция данных всех опросов',
  ArenaMobileDataImportJob: 'Импорт данных Arena',
  ArenaMobileDataImportSummaryJob: 'Сводка импорта данных Arena',
  CategoriesImportJob: 'Импорт категорий',
  CategoriesValidationJob: 'Валидация категорий',
  CategoriesBatchImportJob: 'Импорт категорий',
  CategoryImportJob: 'Импорт категории',
  CategoryImportInternalJob: 'Импорт категории',
  CategoryBatchImportJob: 'Импорт категории',
  CategoryBatchImportInternalJob: 'Импорт категории',
  CategoryValidationJob: 'Валидация категории',
  ChainsSamplingNodeDefsCheckJob: 'Обработка создания определений узлов выборки цепочек',
  ChainsValidationJob: 'Валидация цепочек обработки',
  ChainsImportJob: 'Импорт цепочек',
  CollectDataImportJob: 'Импорт данных Collect',
  CollectImportJob: 'Импорт Collect',
  CollectSurveyReaderJob: 'Чтение опроса Collect',
  CyclesDeletedCheckJob: 'Проверка удаленных циклов',
  DataDeleteJob: 'Удаление данных',
  DataImportJob: 'Импорт данных',
  DataImportValidationJob: 'Валидация файла импорта данных',
  EntitiesDeleteJob: 'Удаление существующих объектов',
  FilesImportJob: 'Импорт файлов',
  MessageSendJob: 'Отправка сообщения',
  NodeDefsTranslationJob: 'Перевод меток определений узлов',
  NodeDefsImportJob: 'Импорт определений узлов',
  NodeDefsValidationJob: 'Валидация определений узлов',
  OdkImportJob: 'Импорт ODK',
  OdkDataImportJob: 'Импорт данных ODK',
  OdkFormReaderJob: 'Чтение формы ODK',
  OdkSubmissionReaderJob: 'Чтение отправок ODK',
  ChainsCyclesCheckJob: 'Проверка циклов цепочек',
  RecordCheckJob: 'Проверка записи',
  RecordsCloneJob: 'Клонирование записей',
  RecordsImportJob: 'Импорт записей',
  RecordsImportSummaryJob: 'Сводка импорта записей',
  RecordsUniquenessValidationJob: 'Валидация уникальности записей',
  SamplingPointDataImportJob: 'Импорт данных точек отбора проб',
  SamplingPointDataImportInternalJob: 'Импорт данных точек отбора проб',
  SchemaSummaryExportJob: 'Экспорт сводки схемы',
  SelectedRecordsExportJob: 'Экспорт выбранных записей',
  SurveyActivityLogClearJob: 'Очистка журнала активности опроса',
  SurveyCreatorJob: 'Создание опроса',
  SurveyDataMigrationJob: 'Миграция данных опроса',
  SurveyDependencyGraphsGenerationJob: 'Генерация графов зависимостей опроса',
  SurveyExportJob: 'Экспорт опроса',
  SurveyCompareJob: 'Сравнение опросов',
  SurveyCompareDiffJob: 'Вычисление различий',
  SurveyCompareApplyJob: 'Применение изменений опроса',
  SurveyFilesImportJob: 'Импорт файлов опроса',
  SurveyIndexGeneratorJob: 'Генератор индекса опроса',
  SurveyInfoValidationJob: 'Валидация информации об опросе',
  SurveyLabelsImportJob: 'Импорт меток опроса',
  SurveyPropsPublishJob: 'Публикация свойств опроса',
  SurveyPublishJob: 'Публикация опроса',
  SurveyPublishPerformJob: 'Выполнение публикации опроса',
  SurveyRdbCreationJob: 'Создание RDB опроса',
  SurveyRdbSchemaCreationJob: 'Создание схемы RDB опроса',
  SurveyRdbDataTablesAndViewsCreationJob: 'Создание таблиц и представлений данных RDB опроса',
  SurveyRdbOlapDataTablesCreationJob: 'Создание таблиц данных OLAP RDB опроса',
  SurveyUnpublishJob: 'Отмена публикации опроса',
  SurveyPropsUnpublishJob: 'Отмена публикации свойств опроса',
  SurveysListExportJob: 'Экспорт списка опросов',
  SurveysRdbRefreshJob: 'Обновление RDB опросов',
  TaxonomiesImportJob: 'Импорт таксономий',
  TaxonomiesValidationJob: 'Валидация таксономий',
  TaxonomyImportJob: 'Импорт таксономии',
  UsersBackupExportJob: 'Резервное копирование пользователей',
  UsersBackupImportJob: 'Восстановление пользователей',
  // data export
  ArenaFileReadJob: 'Чтение файла Arena',
  DataExportJob: 'Экспорт данных',
  DataSummaryExportJob: 'Экспорт сводных данных',
  ZipCreationJob: 'Создание ZIP-файла',
  CSVDataExtraction: 'Извлечение данных',
  FilesExportJob: 'Экспорт файлов',
  PrepareImportFileJob: 'Подготовка файла импорта',
  // geo
  GeoJsonDataExportJob: 'Экспорт данных GeoJson',
  // import arena survey
  ArenaImportJob: 'Импорт Arena',
  ArenaSurveyReaderJob: 'Чтение опроса Arena',
  CreateRdbJob: 'Создание RDB опроса',
  UsersImportJob: 'Импорт пользователей',
  // clone survey
  SurveyCloneJob: 'Клонировать опрос',
  CloneSurveyJob: 'Клонировать опрос',
  // survey backup
  SurveyInfoExportJob: 'Экспорт информации об опросе',
  CategoriesExportJob: 'Экспорт категорий',
  CategoryGeoPackageExportJob: 'Экспорт категории в GeoPackage',
  SamplingPointDataWhispJob: 'Анализ Whisp данных точек выборки',
  SamplingPointDataWhispAnalysisJob: 'Анализ Whisp',
  SamplingPointDataWhispCategoryImportJob: 'Импорт категории Whisp',
  TaxonomiesExportJob: 'Экспорт таксономий',
  RecordsExportJob: 'Экспорт записей',
  RecordFilesExportJob: 'Экспорт файлов записей',
  SurveyFilesExportJob: 'Экспорт файлов опроса',
  ChainExportJob: 'Экспорт цепочки',
  UsersExportJob: 'Экспорт пользователей',
  ActivityLogExportJob: 'Экспорт журнала активности',
  InfoExportJob: 'Формирование информации о выходном файле',
  // validation report
  VaidationReportGenerationJob: 'Сформировать отчет о проверке',
  // record validation
  RecordsValidationJob: 'Проверка записей',
  // analysis
  PersistResultsJob: 'Сохранение результатов анализа',
  PersistOlapDataJob: 'Сохранение данных OLAP',
}
